import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useToast } from '../../../Utils/toastContext';
import ConfirmContinueButton from '../../../Components/ContinueButton/continue-button';
import ConfirmResetButton from '../../../Components/ContinueButton/reset-button';
import { updateFormData } from '../../../Redux/store/onboardingFormSlice';
import LabelWithStatus from '../../../Components/onboarding/label-with-status';
import { clearFileIdsRedux } from '../../../Redux/store/userSlice';
import DocumentUploadWithStatus from '../../../Components/onboarding/file-upload';
import {
  setStepStatusShareholder,
  setRejectedFieldsShareholder,
} from '../../../Redux/store/onboardingFormSlice';
import DocumentPreview from '../../Create-Investment/documentpreview';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

const UploadProofTrust = ({ setCurrentStep }) => {
  const dispatch = useDispatch();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const userStatus = useSelector((state) => state.user.userStatus);
  const stepStatus = useSelector((state) => state.form.stepStatusShareholder);
  const rejectedFields = useSelector(
    (state) => state.form.rejectedFieldsShareholder,
  );
  const [loading, setLoading] = useState(false);
  const { showToast } = useToast();
  const [applicantCountry, setApplicantCountry] = useState(null);
  const [accountTypeId, setAccountTypeId] = useState(null);
  const [description, setDescription] = useState('');
  const [expiryDate, setExpiryDate] = useState('');
  const [stockexchangeLocation, setStockexchangeLocation] = useState('');
  const [currentField, setCurrentField] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentFieldName, setCurrentFieldName] = useState('');
  const [currentFieldValue, setCurrentFieldValue] = useState('');
  const [currentFieldType, setCurrentFieldType] = useState('');
  const [currentDocument, setcurrentDocument] = useState({});
  const [expiryDateSecond, setExpiryDateSecond] = useState('');
  const [fileThirdParty, setFileThirdParty] = useState(null);
  const [fileProof, setFileProof] = useState(null);
  const schemeFileRef = useRef(null);
  const govFundFileRef = useRef(null);
  const extractDocumentFileRef = useRef(null);
  const filePhotoGraphicIdRef = useRef(null);
  const driverLicenseFrontRef = useRef(null);
  const driverLicenseBackRef = useRef(null);
  const fileNonPhotoGraphicIdRef = useRef(null);
  const driverLicenseBackRefFirst = useRef(null);
  const driverLicenseBackRefSecond = useRef(null);
  const publicDocumentFileRef = useRef(null);
  const [fileLicense, setFileLicense] = useState(null);
  const [abnStatus, setAbnStatus] = useState('');
  const [webLink, setWebLink] = useState('');
  const [jurisdiction, setJurisdiction] = useState('');
  const [ticketLink, setTicketLink] = useState('');
  const [abn, setAbn] = useState('');
  const prospectusDocumentFileRef = useRef(null);
  const financialServiceFileRef = useRef(null);
  const foreignRegistrationFileRef = useRef(null);
  const [filePhotographicId, setFilePhotographicId] = useState(null);
  const [fileFinancialService, setFileFinancialService] = useState(null);
  const [fileAmlProgram, setFileAmlProgram] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const { shareholderId } = useParams();

  const mapAgreementUI = (agreement) => {
    return {
      id: agreement.agreement_type.id,
      enum: agreement.agreement_type.enum,
      name: agreement.agreement_type.name,
      description: agreement.agreement_type.description,
      required: agreement.is_required,
      mode: agreement.mode.enum, // UPLOAD_SIGNED | PREVIEW_TICK
      document: agreement.document,
      preview: agreement.preview_document,
      status: agreement.status.enum,
    };
  };

  const [fileForeignRegistration, setFileForeignRegistration] = useState(null);
  const [fileDriverLinsenceFront, setFileDriverLinsenceFront] = useState(null);
  const [fileDriverLinsenceBack, setFileDriverLinsenceBack] = useState(null);
  const [fileDriverLinsenceFrontFirst, setFileDriverLinsenceFrontFirst] =
    useState(null);
  const [fileDriverLinsenceFrontSecond, setFileDriverLinsenceFrontSecond] =
    useState(null);
  const [photoId, setphotoId] = useState(1);
  const [photoIdText, setphotoIdText] = useState('Passport');
  const [nonphotoId, setNonphotoId] = useState(1);
  const [nonphotoIdText, setNonphotoIdText] = useState('Utility Bill');
  const [fileNonPhotographicId, setfileNonPhotographicId] = useState(null);
  const [personalDataId, setPersonalDataId] = useState(1);
  const [personalDataIdText, setPersonalDataIdText] = useState('CV');
  const [licenseNumber, setLicenseNumber] = useState('');
  const fileProofRef = useRef(null);
  const accountantCertificateRef = useRef(null);
  const fileAmlProgramRef = useRef(null);
  const fileCVRef = useRef(null);
  const companyRegistrationFileRef = useRef(null);
  const [agreedMap, setAgreedMap] = useState([]);
  const ticketFileLincenseRef = useRef(null);
  const driverLicenseFrontRefFirst = useRef(null);
  const driverLicenseFrontRefSecond = useRef(null);
  const [hasAml, setHasAml] = useState({
    verification_id: null,
    value: false,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileAccountantCertificate, setFileAccountantCertificate] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [hasLicense, setHasLicense] = useState('no');
  const [ifApplicable, setIfApplicable] = useState('no');
  const [fileTicket, setFileTicket] = useState(null);

  const [fileActivityEvidence, setFileActivityEvidence] = useState(null);
  const [fileCV, setFileCV] = useState(null);
  const [fileCompanyRegistration, setFileCompanyRegistration] = useState(null);

  const registeredSubjectFileRef = useRef(null);
  const activityEvidenceRef = useRef(null);

  const filePhotoGraphicIdNonAusRefSecond = useRef(null);
  const disclosureFileRef = useRef(null);
  const adviceStatementRef = useRef(null);
  const [fileAdviceStatement, setFileAdviceStatement] = useState(null);
  const [photoIdFirst, setphotoIdFirst] = useState(1);
  const [photoIdFirstText, setphotoIdFirstText] = useState('Passport');
  const [photoIdSecond, setphotoIdSecond] = useState(2);
  const [photoIdSecondText, setphotoIdSecondText] =
    useState("Driver's License");

  const [filePhotographicIdFirst, setfilePhotographicIdFirst] = useState(null);
  const [filePhotographicIdSecond, setfilePhotographicIdSecond] =
    useState(null);
  const [filePublicDocument, setFilePublicDocument] = useState(null);
  const [fileDisclosure, setFileDisclosure] = useState(null);

  const [fileDriverLinsenceBackFirst, setFileDriverLinsenceBackFirst] =
    useState(null);
  const [fileDriverLinsenceBackSecond, setFileDriverLinsenceBackSecond] =
    useState(null);
  const [companycategoryId, setCompanycategoryId] = useState(3);
  const [countryId, setCountryId] = useState(4);
  const [showPopup, setShowPopup] = useState(false);
  const [preselectedPhotograpicId, setpreselectedPhotograpicId] = useState({
    value: 1,
    label: 'Passport',
  });
  const [preselectedPhotograpicIdSecond, setpreselectedPhotograpicIdSecond] =
    useState({
      value: 2,
      label: "Driver's License",
    });
  const [preselectedPersonal, setpreselectedPersonal] = useState({
    value: 1,
    label: 'CV',
  });
  const [preselectedNonPhotoId, setpreselectedNonPhotoId] = useState({
    value: 1,
    label: 'Utility Bill',
  });
  const [preselectedPhotograpicIdFirst, setpreselectedPhotograpicIdFirst] =
    useState({
      value: 1,
      label: 'Passport',
    });
  const trustDeedFileRef = useRef(null);
  const selfManagedExtractFileRef = useRef(null);

  const [fileScheme, setFileScheme] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileExtractDocument, setFileExtractDocument] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileGovFund, setFileGovFund] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileTrustDeed, setFileTrustDeed] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileSelfManagedExtract, setFileSelfManagedExtract] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileRegisteredSubject, setFileRegisteredSubject] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileProspectusDocument, setFileProspectusDocument] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const handleFileClick = (e, rowData) => {
    setcurrentDocument(rowData);
    setIsModalOpen(true);
  };
  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    dispatch(clearFileIdsRedux());
    setShowPopup(true);
  };

  const checkFileNameExist = (selectedFile) => {
    const selectedName = selectedFile?.name?.toLowerCase();

    const files = [
      fileScheme,
      fileRegisteredSubject,
      fileTrustDeed,
      fileGovFund,
      fileSelfManagedExtract,
      fileExtractDocument,
      fileProof,
      fileAmlProgram,
      fileAccountantCertificate,
    ];

    return files.some(
      (file) => file?.value?.file_name?.toLowerCase() === selectedName,
    );
  };
  const handleDeleteFileThirdParty = () => {
    setFileProspectusDocument(null);
    if (prospectusDocumentFileRef.current) {
      prospectusDocumentFileRef.current.value = null;
    }
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const fileUploadNew = async (file) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/files/upload`;
    const formData3 = new FormData();
    formData3.append('file', file); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers,
        body: formData3,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }
      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };

  const handleFileChangeProspectusDocument = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (prospectusDocumentFileRef.current) {
          prospectusDocumentFileRef.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileProspectusDocument({
              ...fileProspectusDocument,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: 'error' };
          }
        } catch (err) {
          setFileProspectusDocument({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: 'error' };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
    e.target.value = '';
  };
  const handleDeleteFileProspectusDocument = () => {
    setFileProspectusDocument(null);
    if (prospectusDocumentFileRef.current) {
      prospectusDocumentFileRef.current.value = null;
    }
  };
  const handleFileChangeAccountantCertificate = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (accountantCertificateRef.current) {
          accountantCertificateRef.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileAccountantCertificate({
              ...fileAccountantCertificate,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: 'error' };
          }
        } catch (err) {
          setFileAccountantCertificate({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: 'error' };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
    e.target.value = '';
  };
  const handleDeleteFileScheme = () => {
    setFileScheme(null);
    if (schemeFileRef.current) {
      schemeFileRef.current.value = null;
    }
  };
  const handleDeleteFileAccountantCertificate = () => {
    setFileAccountantCertificate(null);
    if (accountantCertificateRef.current) {
      accountantCertificateRef.current.value = null;
    }
  };
  const shouldShowAgreement = (agreementEnum) => {
    const NON_AU = companycategoryId !== 1;

    if (agreementEnum === 'FATCA_CRS') return NON_AU;
    if (agreementEnum === 'THIRD_PARTY_AUTHORITY') return false;

    return true; // show all others in all cases
  };
  const submitApplicationAPI = async (isFinal) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let isOnboarding = userStatus == 'onboarding' ? true : false;
    let apiUrl = isOnboarding
      ? `${BASE_URL}/api/v1/onboarding/stakeholder/trust/proof-documents/submit/${shareholderId}`
      : `${BASE_URL}/api/v1/onboarding/stakeholder/trust/proof-documents/update/${shareholderId}`;
    const filePayload = (file) =>
      file?.value
        ? {
            file_id: file.value.file_id,
            file_name: file.value.file_name,
          }
        : null;

    const isCategory1 = companycategoryId === 1;
    const isCategory2 = companycategoryId === 2;
    const isCategory3 = companycategoryId === 3;
    const isAustralia = countryId === 14;
    const hasAML = hasAml?.value === true;

    const bodyData = {
      is_submitted: isFinal,
    };

    // ---------- Category 1 ----------
    if (isCategory1) {
      Object.assign(bodyData, {
        managed_investment_scheme_memorandum: filePayload(fileScheme),
        regulatory_oversight_document: filePayload(fileRegisteredSubject),
        government_superannuation_document: filePayload(fileGovFund),
        trust_deed_document: filePayload(fileTrustDeed),
        regulator_database_search_document: filePayload(fileExtractDocument),
        prospectus_document: filePayload(fileProspectusDocument),
      });

      if (isAustralia) {
        bodyData.accountant_certificate_document = filePayload(
          fileAccountantCertificate,
        );
      }
    }

    // ---------- Category 2 ----------
    if (isCategory2 && !isAustralia) {
      Object.assign(bodyData, {
        trust_deed_document: filePayload(fileTrustDeed),
        regulator_database_search_document: filePayload(fileExtractDocument),
        smsf_lookup_extract_document: filePayload(fileSelfManagedExtract),
      });
    }

    // ---------- Category 3 ----------
    if (isCategory3 && !isAustralia) {
      Object.assign(bodyData, {
        trust_deed_document: filePayload(fileTrustDeed),
        prospectus_document: filePayload(fileProspectusDocument),
        satisfies_geographic_link_test: hasAml.value,
      });

      if (hasAML) {
        Object.assign(bodyData, {
          audit_report_document: filePayload(fileProof),
          aml_program_document: filePayload(fileAmlProgram),
        });
      }
    }

    try {
      const response = await fetch(apiUrl, {
        method: isOnboarding ? 'POST' : 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };

  const handleFileChangeScheme = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (schemeFileRef.current) {
          schemeFileRef.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileScheme({
              ...fileScheme,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: 'error' };
          }
        } catch (err) {
          setFileScheme({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: 'error' };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
    e.target.value = '';
  };

  const handleDeleteFileGovFund = () => {
    setFileGovFund(null);
    if (govFundFileRef.current) {
      govFundFileRef.current.value = null;
    }
  };

  const handleFileChangeGovFund = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (govFundFileRef.current) {
          govFundFileRef.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileGovFund({
              ...fileGovFund,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: 'error' };
          }
        } catch (err) {
          setFileGovFund({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: 'error' };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
    e.target.value = '';
  };
  const handleDeleteFileTrustDeed = () => {
    setFileTrustDeed(null);
    if (trustDeedFileRef.current) {
      trustDeedFileRef.current.value = null;
    }
  };

  const handleDeleteFileAuditReport = () => {
    setFileProof(null);
    if (fileProofRef.current) {
      fileProofRef.current.value = null;
    }
  };
  const handleDeleteFileAmlProgram = () => {
    setFileAmlProgram(null);
    if (fileAmlProgramRef.current) {
      fileAmlProgramRef.current.value = null;
    }
  };
  const handleDeleteFileSelfManagedExtract = () => {
    setFileSelfManagedExtract(null);
    if (selfManagedExtractFileRef.current) {
      selfManagedExtractFileRef.current.value = null;
    }
  };

  const handleFileChangeTrustDeed = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (trustDeedFileRef.current) {
          trustDeedFileRef.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileTrustDeed({
              ...fileTrustDeed,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: 'error' };
          }
        } catch (err) {
          setFileTrustDeed({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: 'error' };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
    e.target.value = '';
  };
  const handleFileChangeAuditReport = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (fileProofRef.current) {
          fileProofRef.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileProof({
              ...fileProof,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: 'error' };
          }
        } catch (err) {
          setFileProof({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: 'error' };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
    e.target.value = '';
  };

  const handleFileChangeAmlProgram = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (fileAmlProgramRef.current) {
          fileAmlProgramRef.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileAmlProgram({
              ...fileAmlProgram,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: 'error' };
          }
        } catch (err) {
          setFileAmlProgram({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: 'error' };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
    e.target.value = '';
  };
  const handleFileChangeSelfManagedExtract = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (selfManagedExtractFileRef.current) {
          selfManagedExtractFileRef.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileSelfManagedExtract({
              ...fileSelfManagedExtract,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: 'error' };
          }
        } catch (err) {
          setFileSelfManagedExtract({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: 'error' };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
    e.target.value = '';
  };
  const handleFileChangeAdviceStatement = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (adviceStatementRef.current) {
          adviceStatementRef.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileAdviceStatement(selectedFile);
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
  };
  const handleDeleteFileAdviceStatement = () => {
    setFileAdviceStatement(null);
    if (adviceStatementRef.current) {
      adviceStatementRef.current.value = null;
    }
  };

  const handleFileChangeActivityEvidence = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (activityEvidenceRef.current) {
          activityEvidenceRef.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileActivityEvidence(selectedFile);
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
  };
  const handleDeleteFileForeignRegistration = () => {
    setFileForeignRegistration(null);
    if (foreignRegistrationFileRef.current) {
      foreignRegistrationFileRef.current.value = null;
    }
  };

  const handleFileChangeForeignRegistration = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (foreignRegistrationFileRef.current) {
          foreignRegistrationFileRef.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileForeignRegistration(selectedFile);
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
  };
  const handleDeleteFileCompanyRegistration = () => {
    setFileCompanyRegistration(null);
    if (companyRegistrationFileRef.current) {
      companyRegistrationFileRef.current.value = null;
    }
  };

  const handleFileChangeCompanyRegistration = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (companyRegistrationFileRef.current) {
          companyRegistrationFileRef.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileCompanyRegistration(selectedFile);
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
  };
  const handleSelectPhotographicId = (selectedOption) => {
    console.log('Selected Option:', selectedOption.value);
    setphotoId(selectedOption.value);
    setphotoIdText(selectedOption.label);
    handleDeleteDriverLinsenceBack();
    handleDeleteDriverLinsenceFront();
    handleDeleteFileNonPhotographicId();
    handleDeleteFilePhotographicId();
    setpreselectedNonPhotoId({ value: 1, label: 'Utility Bill' });
    setNonphotoId(null);
  };
  const handleSelectPhotographicIdFirst = (selectedOption) => {
    console.log('Selected Option:', selectedOption.value);
    if (photoIdSecond == selectedOption.value) {
      showToast(
        'The selected photographic ID is already in use. Kindly select a different document.',
        'error',
      );
      setTimeout(() => {
        // Force re-render with previous valid selection
        setpreselectedPhotograpicIdFirst({ ...preselectedPhotograpicIdFirst });
      }, 300);
      return;
    }
    setphotoIdFirst(selectedOption.value);
    setphotoIdFirstText(selectedOption.label);
    handleDeleteDriverLinsenceBackFirst();
    handleDeleteDriverLinsenceFrontFirst();
    setpreselectedPhotograpicIdFirst(selectedOption);
  };
  const handleSelectPhotographicIdSecond = (selectedOption) => {
    console.log('Selected Option:', selectedOption.value);
    if (photoIdFirst == selectedOption.value) {
      showToast(
        'The selected photographic ID is already in use. Kindly select a different document.',
        'error',
      );
      setTimeout(() => {
        // Force re-render with previous valid selection
        setpreselectedPhotograpicIdSecond({
          ...preselectedPhotograpicIdSecond,
        });
      }, 300);
      return;
    }
    setphotoIdSecond(selectedOption.value);
    setphotoIdSecondText(selectedOption.label);
    handleDeleteDriverLinsenceBackSecond();
    handleDeleteDriverLinsenceFrontSecond();
    setpreselectedPhotograpicIdSecond(selectedOption);
  };

  const handleDeleteFileExtractDocument = () => {
    setFileExtractDocument(null);
    if (extractDocumentFileRef.current) {
      extractDocumentFileRef.current.value = null;
    }
  };

  const handleFileChangeExtractDocument = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (extractDocumentFileRef.current) {
          extractDocumentFileRef.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileExtractDocument({
              ...fileExtractDocument,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: 'error' };
          }
        } catch (err) {
          setFileExtractDocument({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: 'error' };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
    e.target.value = '';
  };
  const handleDeleteFileDisclosure = () => {
    setFileDisclosure(null);
    if (disclosureFileRef.current) {
      disclosureFileRef.current.value = null;
    }
  };

  const handleFileChangeDisclosure = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (disclosureFileRef.current) {
          disclosureFileRef.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileDisclosure(selectedFile);
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
  };
  const handleDeleteFileFinancialService = () => {
    setFileFinancialService(null);
    if (financialServiceFileRef.current) {
      financialServiceFileRef.current.value = null;
    }
  };

  const handleFileChangeFinancialService = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (financialServiceFileRef.current) {
          financialServiceFileRef.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileFinancialService(selectedFile);
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
  };
  const handleDeleteFileLicense = () => {
    setFileLicense(null);
    if (ticketFileLincenseRef.current) {
      ticketFileLincenseRef.current.value = null;
    }
  };

  const handleFileChangeLicense = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (ticketFileLincenseRef.current) {
          ticketFileLincenseRef.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileLicense(selectedFile);
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
  };
  const handleDeleteFilePublicDocument = () => {
    setFilePublicDocument(null);
    if (publicDocumentFileRef.current) {
      publicDocumentFileRef.current.value = null;
    }
  };
  const handleFileChangePublicDocument = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (publicDocumentFileRef.current) {
          publicDocumentFileRef.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFilePublicDocument(selectedFile);
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
  };
  const handleFileChangePhotographicId = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (filePhotoGraphicIdRef.current) {
          filePhotoGraphicIdRef.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFilePhotographicId(selectedFile);
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
  };
  const handleFileChangeDriverLincenseFront = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (driverLicenseFrontRef.current) {
          driverLicenseFrontRef.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileDriverLinsenceFront(selectedFile);
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
  };
  const handleFileChangeDriverLincenseFrontFirst = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (driverLicenseFrontRefFirst.current) {
          driverLicenseFrontRefFirst.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileDriverLinsenceFrontFirst(selectedFile);
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
  };
  const handleFileChangeDriverLincenseFrontSecond = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (driverLicenseFrontRefSecond.current) {
          driverLicenseFrontRefSecond.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileDriverLinsenceFrontSecond(selectedFile);
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
  };
  const handleDeleteFilePhotographicId = () => {
    setFilePhotographicId(null);
    if (filePhotoGraphicIdRef && filePhotoGraphicIdRef.current) {
      filePhotoGraphicIdRef.current.value = null;
    }
  };
  const handleDeleteDriverLinsenceFront = () => {
    setFileDriverLinsenceFront(null);
    if (driverLicenseFrontRef && driverLicenseFrontRef.current) {
      driverLicenseFrontRef.current.value = null;
    }
  };
  const handleDeleteDriverLinsenceFrontFirst = () => {
    setFileDriverLinsenceFrontFirst(null);
    if (driverLicenseFrontRefFirst && driverLicenseFrontRefFirst.current) {
      driverLicenseFrontRefFirst.current.value = null;
    }
  };
  const handleDeleteDriverLinsenceFrontSecond = () => {
    setFileDriverLinsenceFrontSecond(null);
    if (driverLicenseFrontRefSecond && driverLicenseFrontRefSecond.current) {
      driverLicenseFrontRefSecond.current.value = null;
    }
  };
  const handleFileChangeDriverLincenseBack = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (driverLicenseBackRef.current) {
          driverLicenseBackRef.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileDriverLinsenceBack(selectedFile);
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
  };
  const handleDeleteDriverLinsenceBack = () => {
    setFileDriverLinsenceBack(null);
    if (driverLicenseBackRef && driverLicenseBackRef.current) {
      driverLicenseBackRef.current.value = null;
    }
  };
  const handleDeleteDriverLinsenceBackFirst = () => {
    setFileDriverLinsenceBackFirst(null);
    if (driverLicenseBackRefFirst && driverLicenseBackRefFirst.current) {
      driverLicenseBackRefFirst.current.value = null;
    }
  };
  const handleDeleteDriverLinsenceBackSecond = () => {
    setFileDriverLinsenceBackSecond(null);
    if (driverLicenseBackRefSecond && driverLicenseBackRefSecond.current) {
      driverLicenseBackRefSecond.current.value = null;
    }
  };
  const handleFileChangeNonPhotographicId = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (fileNonPhotoGraphicIdRef.current) {
          fileNonPhotoGraphicIdRef.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setfileNonPhotographicId(selectedFile);
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
  };

  const handleDeleteFileNonPhotographicId = () => {
    setfileNonPhotographicId(null);
    if (fileNonPhotoGraphicIdRef && fileNonPhotoGraphicIdRef.current) {
      fileNonPhotoGraphicIdRef.current.value = null;
    }
  };
  const handleFileChangeCV = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (fileCVRef.current) {
          fileCVRef.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileCV(selectedFile);
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
  };
  const handleDeleteFileRegisteredSubject = () => {
    setFileRegisteredSubject(null);
    if (registeredSubjectFileRef && registeredSubjectFileRef.current) {
      registeredSubjectFileRef.current.value = null;
    }
  };
  const handleFileChangeRegisteredSubject = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (registeredSubjectFileRef.current) {
          registeredSubjectFileRef.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileRegisteredSubject({
              ...fileRegisteredSubject,
              value: response.data,
            });
          } else {
            toastMessage = { message: response.message, type: 'error' };
          }
        } catch (err) {
          setFileRegisteredSubject({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          toastMessage = { message: err.message, type: 'error' };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
    e.target.value = '';
  };
  const handleFileChangePhotographicIdSecond = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (filePhotoGraphicIdNonAusRefSecond.current) {
          filePhotoGraphicIdNonAusRefSecond.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setfilePhotographicIdSecond(selectedFile);
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
  };
  const handleFileChangeDriverLincenseBackFirst = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (driverLicenseBackRefFirst.current) {
          driverLicenseBackRefFirst.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileDriverLinsenceBackFirst(selectedFile);
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
  };
  const handleFileChangeDriverLincenseBackSecond = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (checkFileNameExist(selectedFile)) {
        if (driverLicenseBackRefSecond.current) {
          driverLicenseBackRefSecond.current.value = null;
        }
        showToast(
          'Please upload the required document; one file with the same name has already been uploaded..',
          'error',
        );
        return;
      }
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileDriverLinsenceBackSecond(selectedFile);
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
  };
  const showError = (condition, message) => {
    if (condition) {
      showToast(message, 'error');
      return true;
    }
    return false;
  };
  const handleContinue = (isFinal) => {
    const isCategory1 = companycategoryId === 1;
    const isCategory2 = companycategoryId === 2;
    const isCategory3 = companycategoryId === 3;
    const isAustralia = countryId === 14;
    const hasAML = hasAml?.value === true;

    // Helper for cleaner validation
    const requireDoc = (condition, file, message) => {
      if (condition && !file?.value) {
        showError(true, message);
        return true;
      }
      return false;
    };

    // ---------- Category 1 ----------
    if (isCategory1) {
      if (
        requireDoc(
          true,
          fileScheme,
          'Please upload a valid managed investment scheme document.',
        )
      )
        return;

      if (
        requireDoc(
          true,
          fileRegisteredSubject,
          'Please upload the regulatory oversight of a regulator document.',
        )
      )
        return;

      if (
        requireDoc(
          true,
          fileGovFund,
          'Please upload a government superannuation fund document.',
        )
      )
        return;

      if (
        requireDoc(
          true,
          fileTrustDeed,
          'Please upload the trust deed document.',
        )
      )
        return;

      if (
        requireDoc(
          true,
          fileExtractDocument,
          'Please upload a search of the relevant ASIC, APRA or other regulator database.',
        )
      )
        return;

      if (
        requireDoc(
          true,
          fileProspectusDocument,
          'Please upload the valid prospectus document.',
        )
      )
        return;

      if (
        requireDoc(
          isAustralia,
          fileAccountantCertificate,
          'Please upload a valid accountant certificate.',
        )
      )
        return;
    }

    // ---------- Category 2 ----------
    if (isCategory2 && !isAustralia) {
      if (
        requireDoc(
          true,
          fileTrustDeed,
          'Please upload the trust deed document.',
        )
      )
        return;

      if (
        requireDoc(
          true,
          fileExtractDocument,
          'Please upload a search of the relevant regulator database.',
        )
      )
        return;

      if (
        requireDoc(
          true,
          fileSelfManagedExtract,
          'Please upload the SMSF lookup extract document.',
        )
      )
        return;
    }

    // ---------- Category 3 ----------
    if (isCategory3 && !isAustralia) {
      if (
        requireDoc(
          true,
          fileTrustDeed,
          'Please upload the trust deed document.',
        )
      )
        return;

      if (
        requireDoc(
          true,
          fileProspectusDocument,
          'Please upload the prospectus document.',
        )
      )
        return;

      // AML-specific docs
      if (hasAML) {
        if (
          requireDoc(
            true,
            fileProof,
            'Please upload the audit report document.',
          )
        )
          return;

        if (
          requireDoc(
            true,
            fileAmlProgram,
            'Please upload the AML program document.',
          )
        )
          return;
      }
    }

    setLoading(true);
    handlesave(isFinal);
  };
  const resetApplicationAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/onboarding/stakeholder/trust/proof-documents/reset/${shareholderId}`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleReset = async () => {
    let toastMessage = null;
    try {
      const response = await resetApplicationAPI();
      if (response.status == 200) {
        toastMessage = {
          message: response.message,
          type: 'success',
        };
        getDetailsWithVerification();
        const responseStatus = await GetAPIcalls(
          `/api/v1/onboarding/stakeholder/status/${shareholderId}`,
        );
        if (responseStatus.status == 200) {
          if (responseStatus.data.length > 0) {
            dispatch(setStepStatusShareholder(responseStatus.data));
          }
        }
        const responseRejected = await GetAPIcalls(
          `/api/v1/onboarding/stakeholder/rejected-fields/${shareholderId}`,
        );
        if (responseRejected.status == 200) {
          dispatch(setRejectedFieldsShareholder(responseRejected.data)); // <-- Save in Redux
        }
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const handleBack = () => {
    setCurrentStep(2);
  };
  const handlesave = async (isFinal) => {
    let toastMessage = null;
    try {
      const response = await submitApplicationAPI(isFinal);
      if (response.status == 200) {
        if (isFinal) {
          setCurrentStep(4);
          toastMessage = {
            message: response.message,
            type: 'success',
          };
          const responseStatus = await GetAPIcalls(
            `/api/v1/onboarding/stakeholder/status/${shareholderId}`,
          );
          if (responseStatus.status == 200) {
            if (responseStatus.data.length > 0) {
              dispatch(setStepStatusShareholder(responseStatus.data));
            }
          }
          const responseRejected = await GetAPIcalls(
            `/api/v1/onboarding/stakeholder/rejected-fields/${shareholderId}`,
          );
          if (responseRejected.status == 200) {
            dispatch(setRejectedFieldsShareholder(responseRejected.data)); // <-- Save in Redux
          }
        } else {
          toastMessage = {
            message:
              'Information has been saved successfully. Please submit to proceed further.',
            type: 'success',
          };
        }
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const getTypes = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1/onboarding/stakeholder/trust/proof-documents/trust-type-country/${shareholderId}`,
      );

      if (response.status == 200) {
        setCompanycategoryId(response.data.trust_type.id);
        setCountryId(response.data.country.id);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  const getDetailsWithVerification = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1/onboarding/stakeholder/trust/proof-documents/preview/${shareholderId}/verifications`,
      );

      if (response.status == 200) {
        if (response.data) {
          setFileScheme(response.data.managed_investment_scheme_memorandum);
          setFileRegisteredSubject(response.data.regulatory_oversight_document);
          setFileGovFund(response.data.government_superannuation_document);
          setFileTrustDeed(response.data.trust_deed_document);
          setFileExtractDocument(
            response.data.regulator_database_search_document,
          );
          setFileProspectusDocument(response.data.prospectus_document);
          setFileAccountantCertificate(
            response.data.accountant_certificate_document,
          );
          setFileSelfManagedExtract(response.data.smsf_lookup_extract_document);
          setHasAml(response.data.satisfies_geographic_link_test);
          setFileProof(response.data.audit_report_document);
          setFileAmlProgram(response.data.aml_program_document);
        } else {
          setFileScheme({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileRegisteredSubject({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileGovFund({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileTrustDeed({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileExtractDocument({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileProspectusDocument({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileAccountantCertificate({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileSelfManagedExtract({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setHasAml({
            verification_id: null,
            value: false,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileProof({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFileAmlProgram({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  useEffect(() => {
    getTypes();
  }, []);
  useEffect(() => {
    if (stepStatus.length > 0 && stepStatus[2].status != 'DRAFT') {
      getDetailsWithVerification();
    }
  }, [stepStatus, countryId, companycategoryId]);
  const fieldLabelMap = {
    managed_investment_scheme_memorandum: 'Managed investment scheme documet',
    regulatory_oversight_document:
      'Regulatory oversight of a regulator document',
    trust_deed_document: 'Trust deed document',
    government_superannuation_document:
      'Government superannuation fund document',
    prospectus_document: 'Prospectus document',
    smsf_lookup_extract_document: 'SMSF lookup extract document',
    regulator_database_search_document:
      'A search of the relevant ASIC, APRA or other regulator database.',
    audit_report_document: 'Audit report',
    aml_program_document: 'AML program document',
    accountant_certificate_document: 'Accountant certificate',
  };
  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[80vw]">
      <div className="flex-grow  overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        {stepStatus.length > 0 &&
          (stepStatus[2].status == 'IN_REVIEW' ||
            stepStatus[2].status == 'COMPLETED') && (
            <div className="mb-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
              <img
                src="/warning-circle.svg"
                alt="Info"
                className="w-4 h-4 mr-2"
              />
              <span>
                This section is{' '}
                <strong>in review by our onboarding team</strong>. You will be
                notified once the verification is complete.{' '}
              </span>
            </div>
          )}

        {stepStatus.length > 0 && stepStatus[2].status == 'APPROVED' && (
          <div className="mb-2 bg-green-100 border-l-4 border-green-500 text-green-700 p-3 rounded-md text-sm flex items-center">
            <span>
              This section has been <strong>approved</strong> by our onboarding
              team.
            </span>
          </div>
        )}
        {rejectedFields?.UPLOAD_PROOF_DOCS?.rejected_fields?.length > 0 && (
          <div className="mb-3 p-3 bg-red-50 border border-red-200 rounded-md">
            <p className="font-semibold text-red-700 mb-1">
              {rejectedFields.UPLOAD_PROOF_DOCS.rejected_fields.length === 1
                ? 'The following field requires correction:'
                : 'The following fields require correction:'}{' '}
            </p>

            <div className="flex flex-wrap gap-2">
              {rejectedFields.UPLOAD_PROOF_DOCS.rejected_fields.map((field) => (
                <span
                  key={field}
                  className="px-2 py-1 bg-red-100 text-red-700 text-xs rounded"
                >
                  {fieldLabelMap[field] || field.replace(/_/g, ' ')}
                </span>
              ))}
            </div>
          </div>
        )}
        <>
          <div className="bg-white shadow-md rounded-md p-4">
            <div className="border-b border-colour-custom pb-2">
              <div className="flex items-center space-x-2 mb-2">
                <img src="/note-2.svg" alt="User Avatar" className="h-6 w-6" />
                <h1 className="text-xl font-medium">Upload Proof Documents</h1>
              </div>

              <ul className="space-y-2 pl-6 pr-2 text-xs font-medium text-black list-disc">
                <li>
                  Please submit all colour copies of the necessary documents.
                </li>
                <li>
                  Resubmitting the application is required if the documents are
                  not submitted in colour.
                </li>
                <li>
                  Please submit documents if your company is an Australian
                  company or submit Notarised documents if your company is
                  Non-Australian.
                </li>
                <li>
                  Please be advised that your application will be subjected to
                  rejection if documents submitted in this section are older
                  than three days!{' '}
                </li>
              </ul>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {/* first column */}
              <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                {companycategoryId == 1 && (
                  <>
                    <div className="">
                      <DocumentUploadWithStatus
                        id="scheme"
                        label="A managed investment scheme that is not registered by Regulator in your specific country and that only has wholesale clients and does not make small scale offerings Memorandum"
                        required={true}
                        fieldData={fileScheme}
                        handleStatusClick={handleStatusClick}
                        fileRef={schemeFileRef}
                        onChange={handleFileChangeScheme}
                        onFileClick={handleFileClick}
                        onDelete={handleDeleteFileScheme}
                      />
                    </div>
                    <div className="mt-4">
                      <DocumentUploadWithStatus
                        id="regulatory"
                        label="Registered and subject to the regulatory oversight of a regulator in relation to its activities as a trust"
                        required={true}
                        fieldData={fileRegisteredSubject}
                        handleStatusClick={handleStatusClick}
                        fileRef={registeredSubjectFileRef}
                        onChange={handleFileChangeRegisteredSubject}
                        onFileClick={handleFileClick}
                        onDelete={handleDeleteFileRegisteredSubject}
                      />
                    </div>
                  </>
                )}
                {companycategoryId != 1 && countryId != 14 && (
                  <div>
                    <DocumentUploadWithStatus
                      id="trustDeed"
                      label="Trust Deed"
                      required={true}
                      fieldData={fileTrustDeed}
                      handleStatusClick={handleStatusClick}
                      fileRef={trustDeedFileRef}
                      onChange={handleFileChangeTrustDeed}
                      onFileClick={handleFileClick}
                      onDelete={handleDeleteFileTrustDeed}
                    />
                  </div>
                )}
                {countryId == 14 && companycategoryId != 1 && (
                  <div className="">
                    <DocumentUploadWithStatus
                      id="uploadProspectus"
                      label="Accountant Certificate"
                      required={true}
                      fieldData={fileAccountantCertificate}
                      handleStatusClick={handleStatusClick}
                      fileRef={accountantCertificateRef}
                      onChange={handleFileChangeAccountantCertificate}
                      onFileClick={handleFileClick}
                      onDelete={handleDeleteFileAccountantCertificate}
                    />
                  </div>
                )}
              </div>
              {/* second column */}
              <div className="flex flex-col pr-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                {companycategoryId == 1 && (
                  <>
                    <div className="">
                      <DocumentUploadWithStatus
                        id="regulatory"
                        label="A government superannuation fund established by legislation."
                        required={true}
                        fieldData={fileGovFund}
                        handleStatusClick={handleStatusClick}
                        fileRef={registeredSubjectFileRef}
                        onChange={handleFileChangeGovFund}
                        onFileClick={handleFileClick}
                        onDelete={handleDeleteFileGovFund}
                      />
                    </div>
                    <div className="mt-4">
                      {' '}
                      <DocumentUploadWithStatus
                        id="trustDeed"
                        label="Trust Deed"
                        required={true}
                        fieldData={fileTrustDeed}
                        handleStatusClick={handleStatusClick}
                        fileRef={trustDeedFileRef}
                        onChange={handleFileChangeTrustDeed}
                        onFileClick={handleFileClick}
                        onDelete={handleDeleteFileTrustDeed}
                      />
                    </div>
                  </>
                )}
                {companycategoryId != 1 && (
                  <div className="">
                    <DocumentUploadWithStatus
                      id="uploadProspectus"
                      label={
                        countryId == 14
                          ? 'A managed investment scheme registered by ASIC - Upload Prospectus Document'
                          : 'A managed investment scheme registered by Regulator in your specific country - Upload Prospectus Document'
                      }
                      required={true}
                      fieldData={fileProspectusDocument}
                      handleStatusClick={handleStatusClick}
                      fileRef={prospectusDocumentFileRef}
                      onChange={handleFileChangeProspectusDocument}
                      onFileClick={handleFileClick}
                      onDelete={handleDeleteFileProspectusDocument}
                    />
                  </div>
                )}
                {companycategoryId == 2 && countryId != 14 && (
                  <div>
                    {' '}
                    <DocumentUploadWithStatus
                      id="selfManagedExtract"
                      label="Self-Managed Super Fund Lookup Extract"
                      required={true}
                      fieldData={fileSelfManagedExtract}
                      handleStatusClick={handleStatusClick}
                      fileRef={selfManagedExtractFileRef}
                      onChange={handleFileChangeSelfManagedExtract}
                      onFileClick={handleFileClick}
                      onDelete={handleDeleteFileSelfManagedExtract}
                    />
                  </div>
                )}
              </div>
              {/* third column */}
              <div className="flex flex-col pr-4 pt-4">
                {(companycategoryId == 1 ||
                  (companycategoryId == 2 && countryId != 14)) && (
                  <>
                    <div className="">
                      <DocumentUploadWithStatus
                        id="relevantASIC"
                        label="A search of the relevant ASIC, APRA or other regulator database"
                        required={true}
                        fieldData={fileExtractDocument}
                        handleStatusClick={handleStatusClick}
                        fileRef={extractDocumentFileRef}
                        onChange={handleFileChangeExtractDocument}
                        onFileClick={handleFileClick}
                        onDelete={handleDeleteFileExtractDocument}
                      />
                    </div>
                    {companycategoryId == 1 && (
                      <div className="mt-4">
                        <DocumentUploadWithStatus
                          id="uploadProspectus"
                          label={
                            countryId == 14
                              ? 'A managed investment scheme registered by ASIC - Upload Prospectus Document'
                              : 'A managed investment scheme registered by Regulator in your specific country - Upload Prospectus Document'
                          }
                          required={true}
                          fieldData={fileProspectusDocument}
                          handleStatusClick={handleStatusClick}
                          fileRef={prospectusDocumentFileRef}
                          onChange={handleFileChangeProspectusDocument}
                          onFileClick={handleFileClick}
                          onDelete={handleDeleteFileProspectusDocument}
                        />
                      </div>
                    )}
                  </>
                )}
                {companycategoryId == 3 && countryId != 14 && (
                  <>
                    <div className="flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                      <label
                        htmlFor="investmentType"
                        className="block whitespace-normal break-words text-sm text-labelColour flex items-center"
                      >
                        Do you satisfy one of the geographical link tests in ss
                        6(6) of the AML/CTF Act or that its name and enrolment
                        details are entered on the Reporting Entities Roll; and
                        that it has carried out all applicable KYC and ongoing
                        customer due diligence requirements in accordance with
                        Chapter 15 of the AML/CTF Rules in relation to its
                        underlying customers, prior to, or at the time of
                        becoming a customer of Caprock.
                        <span className="text-red-500">*</span>
                      </label>

                      {/* Radio Buttons */}
                      <div className="flex items-center gap-4">
                        <label className="flex items-center text-sm text-black">
                          <input
                            type="radio"
                            name="hasAml"
                            value={true}
                            checked={hasAml.value === true}
                            onChange={(e) => {
                              setDescription({
                                verification_id: null,
                                value: '',
                                status: 'pending',
                                rejection_reason: null,
                                rejection_comment: null,
                                rejection_timestamp: null,
                                rejected_by: null,
                                comments: [],
                              });
                              setFileProof({
                                verification_id: null,
                                value: null,
                                status: 'pending',
                                rejection_reason: null,
                                rejection_comment: null,
                                rejection_timestamp: null,
                                rejected_by: null,
                                comments: [],
                              });
                              const value = e.target.value === 'true'; // convert string → boolean
                              setHasAml({
                                ...hasAml,
                                value: value,
                              });
                            }}
                            className="confirm-check w-6 h-4 text-[#375AE7] border-gray-300 focus:ring-[#375AE7]"
                          />
                          <span className="">Yes</span>
                        </label>

                        <label className="flex items-center text-sm text-black">
                          <input
                            type="radio"
                            name="hasAml"
                            value={false}
                            checked={hasAml.value == false}
                            onChange={(e) => {
                              setDescription({
                                verification_id: null,
                                value: '',
                                status: 'pending',
                                rejection_reason: null,
                                rejection_comment: null,
                                rejection_timestamp: null,
                                rejected_by: null,
                                comments: [],
                              });
                              setFileProof({
                                verification_id: null,
                                value: null,
                                status: 'pending',
                                rejection_reason: null,
                                rejection_comment: null,
                                rejection_timestamp: null,
                                rejected_by: null,
                                comments: [],
                              });
                              const value = e.target.value === 'true'; // convert string → boolean
                              setHasAml({
                                ...hasAml,
                                value: value,
                              });
                            }}
                            className="w-6 h-4 confirm-check  border-gray-300 focus:ring-[#375AE7]"
                          />
                          <span className="">No</span>
                        </label>
                      </div>
                    </div>
                    {hasAml.value === true && (
                      <>
                        <div className="mt-4">
                          <DocumentUploadWithStatus
                            id="auditReport"
                            label="Audit Report (Most Recent)"
                            required={true}
                            fieldData={fileProof}
                            handleStatusClick={handleStatusClick}
                            fileRef={fileProofRef}
                            onChange={handleFileChangeAuditReport}
                            onFileClick={handleFileClick}
                            onDelete={handleDeleteFileAuditReport}
                          />
                        </div>
                        <div className="mt-4">
                          <DocumentUploadWithStatus
                            id="amlProgram"
                            label="AML Program"
                            required={true}
                            fieldData={fileAmlProgram}
                            handleStatusClick={handleStatusClick}
                            fileRef={fileAmlProgramRef}
                            onChange={handleFileChangeAmlProgram}
                            onFileClick={handleFileClick}
                            onDelete={handleDeleteFileAmlProgram}
                          />
                        </div>
                      </>
                    )}
                  </>
                )}
                {countryId == 14 && companycategoryId == 1 && (
                  <div className="mt-4">
                    <DocumentUploadWithStatus
                      id="uploadProspectus"
                      label="Accountant Certificate"
                      required={true}
                      fieldData={fileAccountantCertificate}
                      handleStatusClick={handleStatusClick}
                      fileRef={accountantCertificateRef}
                      onChange={handleFileChangeAccountantCertificate}
                      onFileClick={handleFileClick}
                      onDelete={handleDeleteFileAccountantCertificate}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      </div>
      {isModalOpen && currentDocument && (
        <DocumentPreview
          fileUrl={currentDocument.presigned_url}
          fileName={currentDocument?.file_name || currentDocument?.name}
          onClose={() => setIsModalOpen(false)}
        />
      )}
      <footer className="mb-1 bottom-actions flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#375AE7]">
        {stepStatus.length > 0 &&
          stepStatus[2].status != 'COMPLETED' &&
          stepStatus[2].status != 'APPROVED' &&
          stepStatus[2].status != 'IN_REVIEW' && (
            <>
              <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0 relative">
                <ConfirmResetButton
                  onConfirm={handleReset}
                  isReset={true}
                  isBack={true}
                  onBack={handleBack}
                />
              </div>
              <div className="bottom-actions flex flex-col md:flex-row mt-2 md:mt-0 items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4">
                <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
                  {/* Save as Draft */}
                  <button
                    onClick={() => {
                      handleContinue(false);
                    }}
                    className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
                  >
                    <span>Save as Draft</span>
                  </button>

                  <ConfirmContinueButton
                    onContinue={() => handleContinue(true)}
                    buttonText="Continue"
                    confirmTitle="Save Section"
                    confirmMessage="Are you sure, you want to continue. This action will ensure, the saved information is un-editable. Therefore please make sure you have provided the correct details."
                  />
                </div>
              </div>
            </>
          )}
        {stepStatus.length > 0 &&
          (stepStatus[2].status == 'COMPLETED' ||
            stepStatus[2].status == 'APPROVED' ||
            stepStatus[2].status == 'IN_REVIEW') && (
            <>
              <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0 relative">
                <ConfirmResetButton
                  onConfirm={handleReset}
                  isReset={false}
                  isBack={true}
                  onBack={handleBack}
                />
              </div>
              <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
                {/* Save as Draft */}
                <button
                  onClick={() => {
                    setCurrentStep(4);
                  }}
                  className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
                >
                  <span>Next</span>
                </button>
              </div>
            </>
          )}
      </footer>
    </div>
  );
};
export default UploadProofTrust;
